const DraftPopup = ({
    showDraftPopup,
    handleDraftConfirm,
    handleDraftCancel
}) => {
    if (!showDraftPopup) return null;

    return (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg px-4 py-6 mx-4 w-full max-w-sm">
                <h3 className="text-[14px] font-semibold text-gray-900 mb-4 text-center">
                    Are you sure you want to save the video to your drafts?
                </h3>
                <div className="flex items-center space-x-4">

                    <button
                        onClick={handleDraftCancel}
                        className="w-full text-[12px] whitespace-nowrap py-1 px-2 bg-gray-300 text-gray-900 rounded font-medium hover:bg-gray-300 transition-colors"
                    >
                        No
                    </button>
                    <button
                        onClick={handleDraftConfirm}
                        className="w-full text-[12px] whitespace-nowrap py-1 px-2 bg-gray-900 text-white rounded font-medium hover:bg-gray-800 transition-colors"
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DraftPopup;